import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class AsmService {
  private logoutURL = environment.links.asm.logout;
  private httpOptions = {
    headers: new HttpHeaders({
      "X-CSRF-TOKEN": window['ACC']['config']['CSRFToken']
    })
  };

  constructor(private http: HttpClient ) {}

  logoutAsm() {
    return this.http.post(this.logoutURL, null, this.httpOptions);
  }
}
